import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

class EmployersAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      lista_paises: [],
      name: '',
      social_name: '',
      short_name: '',
      address: '',
      number: '',
      complement: '',
      neighborhood: '',
      cep: '',
      city: '',
      province: null,
      country_id: null,
      phone: '',
      phone_2: '',
      email: '',
      email_2: '',
      cnpj: '',
      contact_name: '',
      deprecated: '',
      observations: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.adicionar = this.adicionar.bind(this);
    this.loadData = this.loadData.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData(e) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/paises/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({lista_paises: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }
  adicionar(event) {
    event.preventDefault();
    var datasave = {
      name: this.state.name,
      social_name: this.state.social_name,
      short_name: this.state.short_name,
      address: this.state.address,
      complement: this.state.complement,
      neighborhood: this.state.neighborhood,
      cep: this.state.cep,
      city: this.state.city,
      province: this.state.province,
      number: this.state.number,
      country_id: this.state.country_id,
      phone: this.state.phone,
      phone_2: this.state.phone_2,
      email: this.state.email,
      email_2: this.state.email_2,
      cnpj: this.state.cnpj,
      contact_name: this.state.contact_name,
      observations: this.state.observations,
      deprecated: '0',
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/empregador', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/empregador/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container">
    <div className="conteudo">
      <h3 className="page-title pull-left">Cadastrar Empregador</h3>
      <Link to="/empregadores" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.adicionar}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Nome Fantasia:</label>
              <input type="text" name="name" className="form-control" placeholder="Nome do Empregador" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Razão Social:</label>
              <input type="text" name="social_name" className="form-control" placeholder="Razão Social do Empregador" value={this.state.social_name} onChange={this.handleChange.bind(this, 'social_name')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Nome Curto:</label>
              <input maxLength={5} type="text" name="short_name" className="form-control" placeholder="Nome Curto (05 caracteres)" value={this.state.short_name} onChange={this.handleChange.bind(this, 'short_name')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Endereço:</label>
              <input type="text" name="address" className="form-control" placeholder="Endereço do Empregador" value={this.state.address} onChange={this.handleChange.bind(this, 'address')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Número:</label>
              <input type="text" name="number" className="form-control" placeholder="Número do endereço" value={this.state.number} onChange={this.handleChange.bind(this, 'number')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Complemento:</label>
              <input type="text" name="complement" className="form-control" placeholder="Complemento do endereço" value={this.state.complement} onChange={this.handleChange.bind(this, 'complement')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>CEP:</label>
              <InputMask value={this.state.cep}  maskChar={null} name="cep" mask="99.999-999" className="form-control" onChange={this.handleChange.bind(this, 'cep')} placeholder="CEP do Empregador" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Bairro:</label>
              <input type="text" name="neighborhood" className="form-control" placeholder="Bairro do Empregador" value={this.state.neighborhood} onChange={this.handleChange.bind(this, 'neighborhood')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Cidade:</label>
              <input type="text" name="city" className="form-control" placeholder="Cidade do Empregador" value={this.state.city} onChange={this.handleChange.bind(this, 'city')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>País:</label>
              <Select
                className="form-field-name"
                name="country_id"
                value={this.state.country_id}
                searchable={true}
                placeholder={'Selecionar País'}
                onChange={this.handleSelectChange.bind(this, 'country_id')}
                options={this.state.lista_paises}
              />    
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Estado:</label>
              <Select
                className="form-field-name"
                name="province"
                value={this.state.province}
                searchable={true}
                placeholder={'Estado do Empregador'}
                onChange={this.handleSelectChange.bind(this, 'province')}
                options={[
                  {value: "AC", label: "Acre"},
                  {value: "AL", label: "Alagoas"},
                  {value: "AM", label: "Amazonas"},
                  {value: "AP", label: "Amapá"},
                  {value: "BA", label: "Bahia"},
                  {value: "CE", label: "Ceará"},
                  {value: "DF", label: "Distrito Federal"},
                  {value: "ES", label: "Espírito Santo"},
                  {value: "GO", label: "Goiás"},
                  {value: "MA", label: "Maranhão"},
                  {value: "MT", label: "Mato Grosso"},
                  {value: "MS", label: "Mato Grosso do Sul"},
                  {value: "MG", label: "Minas Gerais"},
                  {value: "PA", label: "Pará"},
                  {value: "PB", label: "Paraíba"},
                  {value: "PR", label: "Paraná"},
                  {value: "PE", label: "Pernambucano"},
                  {value: "PI", label: "Piauí"},
                  {value: "RJ", label: "Rio de Janeiro"},
                  {value: "RN", label: "Rio Grande do Norte"},
                  {value: "RO", label: "Rondônia"},
                  {value: "RS", label: "Rio Grande do Sul"},
                  {value: "RR", label: "Roraima"},
                  {value: "SC", label: "Santa Catarina"},
                  {value: "SE", label: "Sergipe"},
                  {value: "SP", label: "São Paulo"},
                  {value: "TO", label: "Tocantins"},
                ]}
              />    
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Telefone:</label>
              <InputMask value={this.state.phone}  maskChar={null} name="phone" mask="(99) 9999-99999" className="form-control" onChange={this.handleChange.bind(this, 'phone')} placeholder="Telefone do Empregador" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Telefone 2:</label>
              <InputMask value={this.state.phone_2}  maskChar={null} name="phone_2" mask="(99) 9999-99999" className="form-control" onChange={this.handleChange.bind(this, 'phone_2')} placeholder="Telefone 2 do Empregador" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>E-mail:</label>
              <input type="text" name="email" className="form-control" placeholder="E-mail do Empregador" value={this.state.email} onChange={this.handleChange.bind(this, 'email')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>E-mail 2:</label>
              <input type="text" name="email_2" className="form-control" placeholder="E-mail 2 do Empregador" value={this.state.email_2} onChange={this.handleChange.bind(this, 'email_2')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Funcionário de Contato:</label>
              <input type="text" name="contact_name" className="form-control" placeholder="Funcionário de Contato do Empregador" value={this.state.contact_name} onChange={this.handleChange.bind(this, 'contact_name')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>CNPJ:</label>
              <InputMask value={this.state.cnpj}  maskChar={null} name="cnpj" mask="99.999.999/9999-99" className="form-control" onChange={this.handleChange.bind(this, 'cnpj')} placeholder="CNPJ do Empregador" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Observações:</label>
              <textarea style={{ height: 200 }} type="text" name="observations" className="form-control" value={this.state.observations} onChange={this.handleChange.bind(this, 'observations')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Adicionar Empregador</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default EmployersAdd;



// WEBPACK FOOTER //
// ./src/Components/Employers/EmployersAdd.js